import React from "react";

import CircleIcon from "@mui/icons-material/Circle";
import { Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

interface DeploymentStatusButtonProps {
  deploymentStatus: "pending" | "success" | "error" | "failure" | string;
  context: string;
  createdAt: string;
  updatedAt: string;
}

const StatusButton: React.FC<DeploymentStatusButtonProps> = ({ deploymentStatus, context, createdAt, updatedAt }) => {
  const getButtonCircleColor = (status: string) => {
    switch (status) {
      case "pending":
        return "warning";
      case "success":
        return "success";
      case "error":
      case "failure":
        return "error";
      default:
        return "primary";
    }
  };

  const getButtonColor = (status: string) => {
    switch (status) {
      case "pending":
        return "orange";
      case "success":
        return "green";
      case "error":
      case "failure":
        return "red";
      default:
        return "gray";
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <Tooltip title={deploymentStatus}>
          <IconButton
            sx={{
              color: getButtonColor(deploymentStatus),
              borderColor: getButtonColor(deploymentStatus),
              "&:hover": {
                borderColor: getButtonColor(deploymentStatus),
              },
            }}
          >
            <CircleIcon color={getButtonCircleColor(deploymentStatus)} />
          </IconButton>
        </Tooltip>
        <Typography variant="body2">
          {context}
        </Typography>
      </Box >
      {/* <Typography variant="caption" color="textSecondary">
          Created At: {new Date(createdAt).toLocaleString()}
        </Typography> */}
      {/* <Typography variant="caption" color="textSecondary">
          {new Date(updatedAt).toLocaleString()}
        </Typography> */}
    </Box>
  );
};

export default StatusButton;
